import React from 'react';
import { Link } from 'react-router-dom';

export default function CGV() {
  return (
    <>
      <section className="bg-slate-900 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link><span>/</span>
            <span className="text-white">Conditions générales de vente</span>
          </div>
          <h1 className="text-3xl font-extrabold text-white">Conditions générales de vente</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">

          <p>Dernière mise à jour : avril 2026</p>

          <h2>Article 1 — Objet</h2>
          <p>
            Les présentes conditions générales de vente (CGV) régissent les relations contractuelles entre <strong>Apex Rénovation</strong>, SAS au RCS de Châteauroux, SIRET 102 941 028 00015 (ci-après « l'Entreprise ») et tout client (ci-après « le Client ») ayant recours à ses services de rénovation, d'aménagement ou de travaux. Toute commande implique l'acceptation sans réserve des présentes CGV.
          </p>

          <h2>Article 2 — Devis et commande</h2>
          <p>
            Tout projet fait l'objet d'un devis écrit gratuit, établi après visite technique du chantier. Le devis est valable 30 jours à compter de sa date d'émission. La commande est réputée ferme à réception du devis signé avec la mention « Bon pour accord » accompagné de l'acompte prévu.
          </p>
          <p>
            Les estimations indicatives fournies via le configurateur en ligne ne constituent pas un devis contractuel ; elles ont valeur d'ordre de grandeur et sont affinées lors de la visite technique.
          </p>

          <h2>Article 3 — Prix et TVA</h2>
          <p>
            Les prix sont indiqués en euros hors taxes (HT). La TVA applicable est précisée dans le devis selon la nature des travaux et la situation du Client (TVA 5,5 % pour la rénovation énergétique RGE, TVA 10 % pour les travaux résidentiels sur logements de plus de 2 ans, TVA 20 % pour les travaux neufs et locaux commerciaux).
          </p>
          <p>
            L'Entreprise se réserve le droit d'ajuster les prix en cas de variation significative du coût des matériaux ; toute modification sera soumise à l'accord préalable du Client.
          </p>

          <h2>Article 4 — Acompte et modalités de paiement</h2>
          <p>
            Un acompte de 30 % du montant TTC est exigible à la signature du devis. Le solde est réglé à la réception des travaux, après signature du procès-verbal de réception. Les paiements s'effectuent par virement bancaire ou chèque à l'ordre d'Apex Rénovation SAS.
          </p>
          <p>
            Tout retard de paiement entraîne l'application de pénalités au taux d'intérêt légal majoré de 5 points, ainsi qu'une indemnité forfaitaire pour frais de recouvrement de 40 € (art. L.441-10 du Code de commerce).
          </p>

          <h2>Article 5 — Délais d'exécution</h2>
          <p>
            Les délais indicatifs sont précisés dans le devis. Ils courent à compter de la réception de l'acompte et de l'obtention de toutes les autorisations nécessaires. L'Entreprise ne saurait être tenue responsable des retards dus à des causes extérieures (intempéries, délais de livraison fournisseurs, modifications demandées par le Client en cours de chantier).
          </p>

          <h2>Article 6 — Obligations du Client</h2>
          <p>Le Client s'engage à :</p>
          <ul>
            <li>Permettre l'accès au chantier aux horaires convenus</li>
            <li>Avoir obtenu les autorisations administratives nécessaires (permis de construire, autorisation de copropriété, etc.)</li>
            <li>Informer l'Entreprise de toute contrainte technique préexistante connue</li>
            <li>Régler les sommes dues aux échéances prévues</li>
          </ul>

          <h2>Article 7 — Réception des travaux</h2>
          <p>
            À l'achèvement des travaux, une réception contradictoire est organisée. Le procès-verbal de réception signé par les deux parties marque le point de départ des garanties légales. Les réserves éventuelles sont consignées dans le procès-verbal et levées dans un délai convenu.
          </p>

          <h2>Article 8 — Garanties</h2>
          <p>L'Entreprise est couverte par :</p>
          <ul>
            <li><strong>Garantie de parfait achèvement</strong> (art. 1792-6 C. civ.) : 1 an à compter de la réception</li>
            <li><strong>Garantie biennale</strong> (art. 1792-3 C. civ.) : 2 ans pour les éléments d'équipement dissociables</li>
            <li><strong>Garantie décennale</strong> (art. 1792 C. civ.) : 10 ans pour les dommages qui compromettent la solidité de l'ouvrage ou le rendent impropre à sa destination</li>
          </ul>

          <h2>Article 9 — Sous-traitance</h2>
          <p>
            L'Entreprise peut recourir à des sous-traitants pour tout ou partie des travaux. Elle demeure responsable de la bonne exécution de l'ensemble des prestations vis-à-vis du Client.
          </p>

          <h2>Article 10 — Litiges</h2>
          <p>
            En cas de litige, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire. À défaut d'accord, les tribunaux compétents du ressort du siège social d'Apex Rénovation SAS seront seuls compétents. Le droit français est seul applicable.
          </p>
        </div>
      </section>
    </>
  );
}
